import { useState } from 'react'
import { Redirect } from 'react-router-dom'
import { connect }  from 'react-redux'
import queryString  from 'query-string'
import userManager  from '../utils/userManager'

import {
  Button,
  Snackbar,
  Typography,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'
import logo from '../static/images/Logo_PlexHorizon_White.png'
import bg   from '../static/images/horizon-2.png'

const styles = theme => ({
  root: {
    position: 'fixed',
    width:    '100%',
    height:   '100%',
    left:     0,
    top:      0,
    zIndex:   10,
    margin:   0,
    background: `url(${bg}) no-repeat fixed center`,
    overlay: {
      backgroundColor: theme.palette.common.black,
      opacity: 0.9
    }
  },
  container: {
    position:  'absolute',
    left:      '50%',
    top:       '40%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0,0,0,0.1)',
    borderRadius: theme.spacing(3),
    paddingBottom: theme.spacing(5),
  },
  logo: {
    height:     '80%',
    width:      '80%',
    marginLeft:  theme.spacing(5),
  },
  title: {
    marginBottom: theme.spacing(4),
    color: theme.palette.common.white,
  },
  login: {
    display: 'block',
    margin: '0 auto',
    border: '3px solid',
    color: theme.palette.common.white,
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'center',
    color: theme.palette.common.white,
  },
})

const Login = ({ classes, user, router }) => {
  const [errorMessage, setErrorMessage] = useState('')

  if (user !== null) {
    const query = queryString.parse(router.location.search)
    if (query.orig_url) {
      return <Redirect to={query.orig_url} />
    }
  }

  function handleLogin(event) {
    event.preventDefault()
    userManager.signinRedirect()
    .catch(error => {
      setErrorMessage(error.message)
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <img src={logo} alt='Logo' align='center' className={classes.logo} />
        <Typography variant='h5' align='center' className={classes.title}>
          Flight Control System For BVLOS Operations
        </Typography>
        <Button variant='outlined' size='large' className={classes.login} onClick={handleLogin}>
          Login
        </Button>
      </div>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={errorMessage !== ''}
        autoHideDuration={6000}
        onClose={(evt, reason) => { setErrorMessage('') }}>
        <Alert severity='error' variant='filled'>{errorMessage}</Alert>
      </Snackbar>
      <div className={classes.footer}>
        <Typography variant='body2'>
          Copyright (c) {new Date().getFullYear()} Garuda Robotics Pte Ltd. Made in Singapore.
        </Typography>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user:   state.oidc.user,
  router: state.router,
})

export default connect(mapStateToProps, null)(withStyles(styles)(Login))
